import {html, nothing} from 'lit';
import type {
  ImmutableProgram,
  InitialProperties,
  ImmutableResult,
} from '#lit/components/mixins/immutable_component/index.js';
import {makeVariants} from '#lit/components/mixins/immutable_component/index.js';
import type {VariantsFor} from '#lit/types/architecture.js';
import type {SessionContextData} from '#lit/contexts/session.js';
import type {FeatureFlagKey} from '#lit/lib/feature_flags/FeatureFlag.js';

export type Model = {
  valid: boolean;
};

export const Msg = makeVariants({});

export type Msg = VariantsFor<typeof Msg>;

// -- Init

function init(props: InitialProperties): Readonly<Model> {
  const key = <FeatureFlagKey | ''>props.get('key') ?? '';
  const on = <boolean>props.get('on') ?? false;
  const off = <boolean>props.get('off');
  const session = <SessionContextData | undefined>props.get('session');
  const evaluation = key ? session?.enabled(key) : undefined;

  /**
   * As we have on and off attributes,
   * we need to check both values to make a decision
   */
  const expectedValue = off === true ? false : on;

  return {
    valid: !!key && expectedValue === evaluation,
  };
}

// -- Update

function update(_msg: Msg, model: Model): ImmutableResult<Model> {
  return model;
}

// -- View

function view(model: Readonly<Model>) {
  return model.valid ? html`<slot></slot>` : nothing;
}

// -- Program

export const main: ImmutableProgram<Model, Msg> = {
  init,
  update,
  view,
};
